
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M1.25 2.27h37.5v28.89H1.25zM20 31.16v6.57M11.45 37.73h17.1"}}),_c('circle',{attrs:{"cx":"20","cy":"16.72","r":"9.18","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M26.33 10a9.91 9.91 0 000 13.53M13.67 23.49a9.91 9.91 0 000-13.53","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    